import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Avatar from '../Avatar';
import { Tooltip } from '@material-ui/core';

class ImageUpload extends React.Component {
    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            const avatar = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(avatar);
            // clear input value
            event.target.value = '';
            this.props.onAvatarChange(avatar);
        }
    };

    render() {
        const { picture, classes, avatarClassName } = this.props;

        return (
            <React.Fragment>
                <Tooltip title="Upload avatar">
                    <label htmlFor="avatar-input" className={classes.label}>
                        <Avatar
                            className={avatarClassName}
                            src={picture}
                            alt="profile-picture"
                        />
                        <Avatar
                            className={`${classes.icon} ${avatarClassName}`}
                        >
                            <i className="material-icons">photo_camera</i>
                        </Avatar>
                    </label>
                </Tooltip>
                <input
                    className={classes.input}
                    accept="image/*"
                    id="avatar-input"
                    onChange={this.onImageChange}
                    type="file"
                />
            </React.Fragment>
        );
    }
}

ImageUpload.propTypes = {
    onAvatarChange: PropTypes.func.isRequired,
    picture: PropTypes.string.isRequired,
};

const style = ({ spacing, palette }) => ({
    label: {
        position: 'relative',
        '&:hover': {
            '& $icon': {
                visibility: 'visible',
            },
        },
    },
    picture: {
        marginRight: spacing.unit * 2,
        borderRadius: '4px',
    },
    icon: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        left: 0,
        background: palette.background.gray2Color,
        visibility: 'hidden',
    },
    input: {
        display: 'none',
    },
});

export default injectSheet(style)(ImageUpload);



// WEBPACK FOOTER //
// ./src/components/organizationInfo/ImageUpload.js